/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon20Regular = forwardRef('TargetCrosshairIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.001 10A7.999 7.999 0 1 1 18 10 7.999 7.999 0 0 1 2 10Zm1.543-.75A6.501 6.501 0 0 1 9.25 3.544V6.25a.75.75 0 0 0 1.5 0V3.544a6.501 6.501 0 0 1 5.706 5.706H13.75a.75.75 0 0 0 0 1.5h2.706a6.501 6.501 0 0 1-5.706 5.706V13.75a.75.75 0 0 0-1.5 0v2.706a6.501 6.501 0 0 1-5.706-5.706H6.25a.75.75 0 0 0 0-1.5H3.544Z" })));
});
